
// src/data/newsData.js
const newsData = [
  {
    id: 1,
    title: "5 Tips to Prepare for Your Student Visa Interview",
    slug: "student-visa-interview-tips",
    date: "2025-07-20",
    excerpt:
      "Nervous about your student visa interview? Here are five expert tips to Assist you prepare and make a Remarkable impression.",
    content: `Preparing for your student visa interview can be stressful, but it doesn't have to be. Here are five essential tips to Assist you succeed:
    
1. Know your course and university details.
2. Be clear about your career plans.
3. Practice speaking confidently and clearly.
4. Bring all necessary documents organized in a folder.
5. Stay calm and positive during the interview.

At Glide, we prepare every student thoroughly to ensure success.`,
    image: "/assets/news/visa-interview.jpg",
    tags: ["Visa Tips"],
    featured: true,
  },
  {
    id: 2,
    title: "Why OSHC is Important for International Students",
    slug: "why-oshc-matters",
    date: "2025-07-28",
    excerpt:
      "Overseas Student Health Cover is more than just a visa requirement. Learn why it's essential for your stay in Australia.",
    content: `Many international students overlook the importance of OSHC until it's too late. Here's why it's critical:

- Covers hospital, ambulance, and GP visits.
- Protects you from high out-of-pocket expenses.
- Required to maintain a valid visa.
- Peace of mind for you and your family.

Let Glide guide you to the right provider at the right price.`,
    image: "/assets/news/oshc.jpg",
    tags: ["Insurance", "Health"],
    featured: false,
  },
  {
    id: 3,
    title: "485 Visa Processing Time Reduced to 7 Days",
    slug: "home-affairs-485-update",
    date: "2025-08-01",
    excerpt:
      "The Department of Home Affairs has announced faster processing for Temporary Graduate Visa (Subclass 485) starting August 2025.",
    content: `As part of ongoing migration reforms, Home Affairs now processes 485 visa applications within an average of 7 days.

This change aims to support post-study work rights and encourage skilled graduates to remain in Australia.

For assistance with 485 visa or migration advice, contact Glide's visa experts today.`,
    image: "/assets/news/home-affairs.jpg",
    tags: ["Home Affairs", "485 Visa", "Official"],
    featured: true,
  },
  {
    id: 4,
    title: "🇦🇺 Official 2025 Update on English Language & Passport Requirements",
    slug: "2025-english-passport-update",
    date: "2025-08-06",
    excerpt:
      "The Department of Home Affairs has released new scoring criteria for CELPIP, IELTS, PTE, OET, and more for 2025 visa levels.",
    content: `📢 The Department of Home Affairs has updated the English Language and Passport Requirements for 2025. This includes new benchmarks for:

- CELPIP General
- IELTS Academic & General
- PTE Academic
- OET
- MET
- LanguageCert

Each skill band (Listening, Reading, Writing, Speaking) is matched with new visa level categories (Vocational, Competent, Proficient, Superior).

📄 View the full official document here:  
👉 [Click to open](https://www.legislation.gov.au/F2025L00905/asmade/text)

This impacts most skilled visa subclasses.  
For advice or application Assist, contact Glide’s registered consultants.`,
    image: "/assets/news/english-requirement-2025.jpg",
    tags: ["Home Affairs", "English Test", "Visa Changes", "Official"],
    featured: true
  }
];

export default newsData;
